import React from "react";
import * as d3 from 'd3';

import classes from './bird_page.module.css';

import * as dateish from "js/dateish";
import { speciesStreaks, streakDays } from "js/ebird/agg";

import DataTable from "web/ui/data_table";
import { Observation } from "js/ebird/ebird";
import { LinkDoY } from "web/ui/date_link";
import { useAppSelector, useTaxonomy } from "web/hooks";
import { getObservations } from "web/app_slice";

const BirdPage = ({ spcode }: { spcode: string }) => {
  const allObservations = useAppSelector(getObservations);

  const taxonomy = useTaxonomy()!;
  const taxon = taxonomy.code(spcode); // TODO: Return null?
  if (taxon == null) {
    return <div>404: Invalid Species Code: <pre>{ spcode }</pre></div>;
  }

  // TODO: Rock Pigeon doesn't work... because of my countAs hack - still true?
  // TODO: Figure out how to share the observation lists
  const observations = allObservations.filter(o => o.taxon.speciesCode === spcode);
  const [[, streaks]] = speciesStreaks(observations);

  // TODO: Use the taxon link but all the root component to be an <h2>
  // Or rather, combine the taxon rendering into a pair of things that can be reused
  // And then allow for them to be wrapped in a link instead...
  return <div className={ classes.root }>
    <h2 className={ classes.species }>
      <span className={ classes.common }>{taxon.commonName} </span>
      <span className={ classes.scientific }><i>{taxon.scientificName}</i></span>
    </h2>

    <BirdCal observations={ observations } />

    <div className={ classes.content }>
      <h3>Streaks</h3>
      <DataTable header={ [ 'Days', 'Start', 'End' ] }
        rows={ streaks.slice(0, 5).map(s => {
          return [ streakDays(s), dateish.yearMonDay(s[0].date), dateish.yearMonDay(s.slice(-1)[0].date) ];
        }) }/>
      <div>TODO: Link to show all streaks for the bird</div>

    </div>
  </div>;
}

// TODO: Take a list of observations and just mark the days/month w/out regard for the taxon...
// Then I can also control the rendering by saying to aggregate the observations by day
//  - e.g. checks vs counts
//  - e.g. months are species vs days
// TODO: This is the "BingoCalendar" - e.g. days that match get a dot...
export const BirdCal = ({ observations }: { observations: Observation[] }) => {
  // We want the midpoint as our checked color
  // const scheme = d3.schemeOrRd[3] as string[]; // TODO: This is the same scheme....
  // const interp = d3.interpolateRgbBasis(scheme);
  // const checked = d3.scaleSequential([0, 2], interp).unknown("");

  const byDay = d3.group(observations, obs => `${obs.date.month}-${obs.date.day}` as dateish.DoY)
  const byMonth = d3.group(observations, obs => obs.date.month, obs => obs.date.day);

  return <>
    <div>{ `Seen ${byDay.size} days` }</div>
    <div className={ classes.bingo_cal }>
      { dateish.yearless().map(moy => {
        return <table key={ moy.mm } className={ classes.month }>
          <thead>
            <tr><th colSpan={7}>
              { moy.name }
              { byMonth.get(moy.mm) &&
                <span className={ classes.count }> ({ byMonth.get(moy.mm)?.size })</span>
              }
            </th></tr>
          </thead>
          <tbody>
            { moy.weeks.map((week, i) => {
              return <tr key={ `${moy}w${i}` } className={ classes.week }>
                { week.map(day => {
                  const doy = day.date as dateish.DoY;
                  const seen = byDay.get(doy) != null;
                  return <td key={ doy } className={ classes.day } data-seen={ seen }>
                    <LinkDoY doy={ doy } >{ day.day }</LinkDoY>
                  </td>
                }) }
              </tr>;
            }) }
          </tbody>
        </table>;
      }) }
    </div>
  </>;
}

export default BirdPage;
